import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Section = styled.section`
  margin-bottom: ${props => props.sectionMargin};
  margin-left: auto;
  margin-right: auto;
  max-width: ${props => props.maxWidth || 'unset'};
  padding: ${props => props.padding || 'unset'};
  position: relative;
  text-align: ${props => (props.textAlign ? 'center' : 'left')};
`;

const StyledSection = ({ children, textAlign, className, sectionMargin, maxWidth, padding }) => {
  return (
    <Section
      textAlign={textAlign}
      className={className}
      sectionMargin={sectionMargin}
      maxWidth={maxWidth}
      padding={padding}
    >
      {children}
    </Section>
  );
};

StyledSection.propTypes = {
  children: PropTypes.node,
  textAlign: PropTypes.string,
  className: PropTypes.string,
  sectionMargin: PropTypes.string,
  maxWidth: PropTypes.string,
  padding: PropTypes.string,
};

export default StyledSection;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/common/Section.js